<div class="container m-b-20 layout-row align-end">
  <button mat-raised-button color="primary" (click)="downloadCSV()">
    <fa-icon icon="file" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Download CSV' | translate }}
  </button>
</div>

<div class="container layout-row-wrap gap-8px responsive-column">
  <mat-form-field class="flex-48">
    <mat-label>{{ 'labels.inputs.Resource ID' | translate }}</mat-label>
    <input matInput [formControl]="resourceId" />
  </mat-form-field>

  <mat-form-field class="flex-48">
    <mat-label>{{ 'labels.inputs.Status' | translate }}</mat-label>
    <mat-select [formControl]="processingResult" (selectionChange)="applyFilter($event.value, 'processingResult')">
      @for (processingResult of auditTrailSearchTemplateData.processingResults; track processingResult) {
        <mat-option [value]="processingResult.id">
          {{ processingResult.processingResult }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="flex-48">
    <mat-label>{{ 'labels.inputs.User' | translate }}</mat-label>
    <input matInput [formControl]="user" [matAutocomplete]="userNameAutocomplete" />
  </mat-form-field>

  <mat-form-field class="flex-48">
    <mat-label>{{ 'labels.inputs.Action' | translate }}</mat-label>
    <input matInput [formControl]="actionName" [matAutocomplete]="actionNameAutocomplete" />
  </mat-form-field>

  <mat-form-field class="flex-48">
    <mat-label>{{ 'labels.inputs.Entity' | translate }}</mat-label>
    <input matInput [formControl]="entityName" [matAutocomplete]="entityNameAutocomplete" />
  </mat-form-field>

  <mat-form-field class="flex-48">
    <mat-label>{{ 'labels.inputs.Checker' | translate }}</mat-label>
    <input matInput [formControl]="checker" [matAutocomplete]="checkerAutocomplete" />
  </mat-form-field>

  <div class="flex-48 layout-row-wrap gap-8px">
    <mat-form-field class="flex-60" (click)="fromDatePicker.open()">
      <mat-label>{{ 'labels.inputs.Maker From Date' | translate }}</mat-label>
      <input
        matInput
        [min]="minDate"
        [max]="maxDate"
        [matDatepicker]="fromDatePicker"
        [formControl]="fromDate"
        placeholder="yyyy-MM-dd"
      />
      <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #fromDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex-38">
      <mat-label>{{ 'labels.inputs.Time' | translate }}</mat-label>
      <input matInput type="time" step="1" [formControl]="fromTime" placeholder="HH:MM:SS" class="time-input" />
    </mat-form-field>
  </div>

  <div class="flex-48 layout-row-wrap gap-8px">
    <mat-form-field class="flex-60" (click)="toDatePicker.open()">
      <mat-label>{{ 'labels.inputs.Maker To Date' | translate }}</mat-label>
      <input
        matInput
        [min]="minDate"
        [max]="maxDate"
        [matDatepicker]="toDatePicker"
        [formControl]="toDate"
        placeholder="yyyy-MM-dd"
      />
      <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #toDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex-38">
      <mat-label>{{ 'labels.inputs.Time' | translate }}</mat-label>
      <input matInput type="time" step="1" [formControl]="toTime" placeholder="HH:MM:SS" class="time-input" />
    </mat-form-field>
  </div>

  <div class="flex-48 layout-row-wrap gap-8px">
    <mat-form-field class="flex-60" (click)="checkedFromDatePicker.open()">
      <mat-label>{{ 'labels.inputs.Checker From Date' | translate }}</mat-label>
      <input
        matInput
        [min]="minDate"
        [max]="maxDate"
        [matDatepicker]="checkedFromDatePicker"
        [formControl]="checkedFromDate"
        placeholder="yyyy-MM-dd"
      />
      <mat-datepicker-toggle matSuffix [for]="checkedFromDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #checkedFromDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex-38">
      <mat-label>{{ 'labels.inputs.Time' | translate }}</mat-label>
      <input matInput type="time" step="1" [formControl]="checkedFromTime" placeholder="HH:MM:SS" class="time-input" />
    </mat-form-field>
  </div>

  <div class="flex-48 layout-row-wrap gap-8px">
    <mat-form-field class="flex-60" (click)="checkedToDatePicker.open()">
      <mat-label>{{ 'labels.inputs.Checked To Date' | translate }}</mat-label>
      <input
        matInput
        [min]="minDate"
        [max]="maxDate"
        [matDatepicker]="checkedToDatePicker"
        [formControl]="checkedToDate"
        placeholder="yyyy-MM-dd"
      />
      <mat-datepicker-toggle matSuffix [for]="checkedToDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #checkedToDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex-38">
      <mat-label>{{ 'labels.inputs.Time' | translate }}</mat-label>
      <input matInput type="time" step="1" [formControl]="checkedToTime" placeholder="HH:MM:SS" class="time-input" />
    </mat-form-field>
  </div>
</div>

<!-- Autocomplete data -->
<mat-autocomplete autoActiveFirstOption #userNameAutocomplete="matAutocomplete" [displayWith]="displayUserName">
  @for (user of filteredUserData | async; track user) {
    <mat-option [value]="{ id: user.id, name: user.username }">
      {{ user.username }}
    </mat-option>
  }
</mat-autocomplete>

<mat-autocomplete autoActiveFirstOption #actionNameAutocomplete="matAutocomplete" [displayWith]="displayActionName">
  @for (action of filteredActionData | async; track action) {
    <mat-option [value]="action">
      {{ action }}
    </mat-option>
  }
</mat-autocomplete>

<mat-autocomplete autoActiveFirstOption #entityNameAutocomplete="matAutocomplete" [displayWith]="displayEntityName">
  @for (entity of filteredEntityData | async; track entity) {
    <mat-option [value]="entity">
      {{ entity }}
    </mat-option>
  }
</mat-autocomplete>

<mat-autocomplete autoActiveFirstOption #checkerAutocomplete="matAutocomplete" [displayWith]="displayUserName">
  @for (user of filteredCheckerData | async; track user) {
    <mat-option [value]="{ id: user.id, name: user.username }">
      {{ user.username }}
    </mat-option>
  }
</mat-autocomplete>

<div class="container mat-elevation-z8 table-container">
  @if (isLoading) {
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }
  @if (!isLoading) {
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Trail ID' | translate }}</th>
        <td mat-cell *matCellDef="let auditTrail">{{ auditTrail.id }}</td>
      </ng-container>
      <ng-container matColumnDef="resourceId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Resource ID' | translate }}</th>
        <td mat-cell *matCellDef="let auditTrail">{{ auditTrail.resourceId }}</td>
      </ng-container>
      <ng-container matColumnDef="processingResult">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Status' | translate }}</th>
        <td mat-cell *matCellDef="let auditTrail">{{ auditTrail.processingResult }}</td>
      </ng-container>
      <ng-container matColumnDef="maker">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Made By' | translate }}</th>
        <td mat-cell *matCellDef="let auditTrail">{{ auditTrail.maker }}</td>
      </ng-container>
      <ng-container matColumnDef="actionName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Action' | translate }}</th>
        <td mat-cell *matCellDef="let auditTrail">{{ auditTrail.actionName }}</td>
      </ng-container>
      <ng-container matColumnDef="entityName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Entity' | translate }}</th>
        <td mat-cell *matCellDef="let auditTrail">{{ auditTrail.entityName }}</td>
      </ng-container>
      <ng-container matColumnDef="officeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Office' | translate }}</th>
        <td mat-cell *matCellDef="let auditTrail">{{ auditTrail.officeName }}</td>
      </ng-container>
      <ng-container matColumnDef="madeOnDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Made Date' | translate }}</th>
        <td mat-cell *matCellDef="let auditTrail">{{ auditTrail.madeOnDate | datetimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="checker">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Checker' | translate }}</th>
        <td mat-cell *matCellDef="let auditTrail">{{ auditTrail.checker }}</td>
      </ng-container>
      <ng-container matColumnDef="checkedOnDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Checked Date' | translate }}</th>
        <td mat-cell *matCellDef="let auditTrail">{{ auditTrail.checkedOnDate | datetimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="clientIp">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Client Ip' | translate }}</th>
        <td mat-cell *matCellDef="let auditTrail">{{ auditTrail.ip }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [routerLink]="[row.id]" class="select-row"></tr>
    </table>
  }

  @if (!isLoading) {
    <mat-paginator
      [length]="dataSource?.records$ | async"
      [pageSize]="10"
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
    ></mat-paginator>
  }
</div>
